import { Controller } from "@hotwired/stimulus"

// Client-side "type to filter" for a long checkbox list (producers, calibers).
// Hides non-matching items as you type. Does not submit anything; it stops the
// input event from bubbling so the surrounding filter form's auto-apply isn't
// triggered.
export default class extends Controller {
  static targets = ["item"]

  filter(event) {
    event.stopPropagation()
    const query = event.target.value.trim().toLowerCase()
    this.itemTargets.forEach((item) => {
      const matches = item.textContent.toLowerCase().includes(query)
      item.style.display = matches ? "" : "none"
    })
  }
}
